import { render, staticRenderFns } from "./ResearchAssist.vue?vue&type=template&id=95771912&scoped=true&"
import script from "./ResearchAssist.vue?vue&type=script&lang=js&"
export * from "./ResearchAssist.vue?vue&type=script&lang=js&"
import style0 from "./ResearchAssist.vue?vue&type=style&index=0&id=95771912&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95771912",
  null
  
)

export default component.exports